import React, { useState } from "react";
import { NumericFormat } from "react-number-format";
import { useFormContext, useController } from "react-hook-form";

const InputCurrencyField = (props) => {
  const { labelClass = "", requiredClass = {} } = props;
  const onChangeCallback = props?.handleOnChange || function () { };
  const { control, setValue } = useFormContext();
  const {
    field,
    fieldState: { error },
  } = useController({
    name: props.source,
    control,
  });
  const prefix = " $ ";
  const handleValueChange = (valueObj) => {
    const { value } = valueObj;
    setValue(props.source, value, {
      shouldValidate: true, 
      shouldDirty: true,
    });
    onChangeCallback(value);
  };

  return (
    <>
      <div className="emp-inputs">
        <label
          htmlFor={props.source}
          className={`form-label ${error && "text-danger"} ${labelClass}`}
        >
          {props.label} {props.required && <span className="red">*</span>}
        </label>
        <NumericFormat
          value={field.value}
          className={`form-control cus-input-control ${props.required && field.value < 0 && "is-warning"
            } ${error && "is-invalid"}`}
          disabled={props.disabled || false}
          prefix={prefix}
          placeholder="$ 0.00"
          allowNegative={props?.allowNegative ? (props?.allowNegative) : false}
          onValueChange={handleValueChange}
          decimalScale={2}
          fixedDecimalScale={true}
          thousandSeparator=","
        />
        <div className="invalid-feedback" style={requiredClass}>
          {error && error.message}
        </div>
      </div>
    </>
  );
};

export default InputCurrencyField;
